module.exports = __webpack_public_path__ + "static/img/11.9b85a8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/11.png
// module id = y1xj
// module chunks = 0